import './clientNavbar.scss';
import { FaFacebookF, FaInstagram, FaBars,FaTiktok,FaPhoneAlt } from "react-icons/fa";
import { useState, useEffect, useRef } from "react";
import logo from '../../images/logo.svg';
import { NavLink } from 'react-router-dom';



const ClientNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  // ✅ Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <nav className="client-navbar" ref={navRef}>
      <div className="navbar-content">

        {/* Burger Menu */}
        <div className="burger" onClick={() => setMenuOpen(!menuOpen)}>
          <FaBars />
        </div>

        {/* Left Links */}
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          <li><NavLink to="/"  className={({ isActive }) => (isActive ? "active" : "")} onClick={() => setMenuOpen(false)}>Home</NavLink></li>
          <li><NavLink to="https://order.ranna.co.uk/e2417bce-8a16-40c6-d9be-81deb5c8fced" target='_blank'  className={({ isActive }) => (isActive ? "active" : "")} onClick={() => setMenuOpen(false)}>Menu</NavLink></li>
          <li><NavLink to="testimonyp"  className={({ isActive }) => (isActive ? "active" : "")} onClick={() => setMenuOpen(false)}>Testimonials</NavLink></li>
          <li><NavLink to="gallery"  className={({ isActive }) => (isActive ? "active" : "")}  onClick={() => setMenuOpen(false)}>Gallery</NavLink></li>
          <li><NavLink to="contact"  className={({ isActive }) => (isActive ? "active" : "")} onClick={() => setMenuOpen(false)}>Contact</NavLink></li>
        </ul>

        {/* Center Logo */}
        <div className="logo-container">
          <img src={logo} alt="Logo" />
        </div>

        {/* Right Side */}
        <div className="right-side">
          <div className="telephone">
            <NavLink to="tel:02077014646"><FaPhoneAlt className='tIcon'/> 020 7701 4646</NavLink>
          </div>

          <div className="socials">
            <NavLink to="#" className="facebook"><FaFacebookF /></NavLink>
            <NavLink to="#" className="tiktok"><FaTiktok /></NavLink>
            <NavLink to="#" className="instagram"><FaInstagram /></NavLink>
          </div>

          <div className="order-btn">
            <button onClick={()=> window.open("https://order.ranna.co.uk/e2417bce-8a16-40c6-d9be-81deb5c8fced/shop/category/24267189-36c6-4747-f4d9-b8ff7c0b267f","_blank")}>Order Online</button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default ClientNavbar;
